import { Theme } from '../interfaces/styled';

const theme = {
  family: '"SF Pro", sans-serif',
  colors: {
    light: '#FFFFFF',
    dark: '#000000',
    bg: '#3D9AC1'
  }
};

export const laptopTheme: Theme = {
  ...theme,
  fontSize: {
    lg: 28,
    md: 24,
    sm: 14
  },
};

export const desktopTheme: Theme = {
  ...theme,
  fontSize: {
    lg: 56,
    md: 48,
    sm: 28
  },
};
